<template>
  <div class="public-receipt-root">
    <div class="brand-bar no-print">
      <img src="/assets/images/paysol_logo.png" alt="Paysol" class="brand-logo" />
      <span class="brand-tag">{{ t('publicReceipt.brandTag') }}</span>
      <LanguageToggle />
    </div>

    <div v-if="loading" class="loader">{{ t('common.loading') }}</div>

    <div v-else-if="!data" class="error-panel">
      <h2>{{ t('publicReceipt.notFound') }}</h2>
      <p>{{ t('publicReceipt.notFoundSub') }}</p>
    </div>

    <div v-else class="wrap">
      <div class="paper">
        <PrintableReceipt
          :sale="data.sale" :tenant="data.tenant" :shop="data.shop"
          :cashier="data.cashier" :customer="data.customer"
          :items="data.items" :payments="data.payments"
          width-class="digital"
        />
      </div>
      <div class="actions no-print">
        <button class="primary" @click="print"><i class="mdi mdi-printer"></i> {{ t('publicReceipt.print') }}</button>
        <button class="secondary" @click="download"><i class="mdi mdi-download"></i> {{ t('publicReceipt.saveCopy') }}</button>
      </div>
      <p class="foot no-print">
        Powered by <a href="https://www.paysol.africa" target="_blank">Paysol</a>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { paysol } from '@/api';
import PrintableReceipt from './PrintableReceipt.vue';
import { t } from '@/i18n';
import LanguageToggle from '@/i18n/LanguageToggle.vue';

export default {
  name: 'PublicReceiptPage',
  components: { PrintableReceipt, LanguageToggle },
  data() { return { localeTick: 0, loading: true, data: null }; },
  async mounted() {
    this._onLoc = () => { this.localeTick++; };
    window.addEventListener('paysol-locale-changed', this._onLoc);
    await this.load();
  },
  beforeUnmount() {
    if (this._onLoc) window.removeEventListener('paysol-locale-changed', this._onLoc);
  },
  methods: {
    t(key, vars) { this.localeTick; return t(key, vars); },
    async load() {
      try {
        const { data } = await axios.post(paysol, { function: 'publicReceipt', receiptNo: this.$route.params.receiptNo });
        if (data.success) {
          this.data = data.data;
          // Auto-print if URL asked for it (POS "Print receipt" flow)
          if (this.$route.query.autoprint === '1' || (typeof window !== 'undefined' && window.location.hash.includes('autoprint=1'))) {
            this.$nextTick(() => setTimeout(() => window.print(), 400));
          }
        }
      } finally { this.loading = false; }
    },
    print() { window.print(); },
    download() { window.print(); /* browser "save as PDF" via print dialog */ },
  }
};
</script>

<style scoped>
.public-receipt-root { min-height: 100vh; background: var(--paysol-bg); color: var(--paysol-text); font-family: var(--paysol-font); }
.brand-bar { background: var(--paysol-bg-elev); padding: 12px 20px; border-bottom: 1px solid var(--paysol-line); display: flex; align-items: center; justify-content: space-between; }
.brand-logo { height: 32px; filter: brightness(1.05); }
.brand-tag { color: var(--paysol-muted); font-size: 11px; text-transform: uppercase; letter-spacing: 1px; }
.wrap { max-width: 420px; margin: 0 auto; padding: 20px 16px; }
.paper { background: #fff; border-radius: 6px; box-shadow: 0 6px 20px rgba(0,0,0,0.35); overflow: hidden; }
.actions { display: flex; gap: 8px; justify-content: center; margin-top: 16px; }
.actions button { display: inline-flex; align-items: center; gap: 6px; padding: 10px 18px; }
.actions button i { font-size: 16px; }
.loader, .error-panel { text-align: center; padding: 60px 20px; color: var(--paysol-muted); }
.error-panel h2 { color: var(--paysol-text); margin: 0 0 8px; }
.foot { text-align: center; color: var(--paysol-muted); font-size: 11px; margin-top: 20px; }
.foot a { color: var(--paysol-teal); text-decoration: none; }

@media print {
  .no-print { display: none !important; }
  .public-receipt-root { background: #fff; padding: 0; }
  .wrap { max-width: none; padding: 0; margin: 0; }
  .paper { box-shadow: none; }
}
</style>
